import { Link } from "react-router-dom";

export default function FooterSection() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="md:col-span-5">
            <Link to="/" className="inline-block">
              <span className="font-heading text-3xl md:text-4xl font-bold text-background-50 tracking-tight">
                ACBuy Wiki
              </span>
            </Link>
            <p className="text-xs md:text-sm text-background-50/60 mt-5 max-w-sm leading-relaxed">
              The most advanced <strong className="text-background-50/80">acbuyspreadsheet</strong>{" "}
              comparison and tracking system for smarter online shopping. Updated daily with the
              latest product data across 14 categories.
            </p>
            <div className="flex items-center gap-3 mt-6">
              {["ri-twitter-x-line", "ri-instagram-line", "ri-linkedin-line", "ri-github-line"].map(
                (icon, idx) => (
                  <a
                    key={idx}
                    href="#"
                    className="w-9 h-9 flex items-center justify-center rounded-full border border-background-50/20 text-background-50/60 hover:text-background-50 hover:border-background-50/40 transition-all duration-200 cursor-pointer"
                    aria-label={`Social media link ${idx + 1}`}
                  >
                    <i className={`${icon} text-sm`}></i>
                  </a>
                )
              )}
            </div>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-3">
            <h4 className="text-xs font-semibold text-background-50/40 uppercase tracking-widest mb-4">
              Quick Links
            </h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/"
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/acbuyspreadsheet-guide"
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                >
                  Shopping Guide
                </Link>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                >
                  Main Platform
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                >
                  Buy It Now
                </a>
              </li>
            </ul>
          </div>

          {/* Articles */}
          <div className="md:col-span-4">
            <h4 className="text-xs font-semibold text-background-50/40 uppercase tracking-widest mb-4">
              ACBuy Spreadsheet Articles
            </h4>
            <div className="grid grid-cols-2 gap-x-4 gap-y-3">
              <Link
                to="/acbuyspreadsheet-guide"
                className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
              >
                Complete Guide
              </Link>
              <Link
                to="/acbuyspreadsheet-vs"
                className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
              >
                vs Traditional
              </Link>
              <Link
                to="/acbuyspreadsheet-pricing"
                className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
              >
                Pricing Guide
              </Link>
              <Link
                to="/acbuyspreadsheet-tips"
                className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
              >
                Tips and Tricks
              </Link>
              <Link
                to="/acbuyspreadsheet-safety"
                className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
              >
                Safety and Trust
              </Link>
              <Link
                to="/acbuyspreadsheet-beginners"
                className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
              >
                Beginner&apos;s Guide
              </Link>
              <Link
                to="/acbuyspreadsheet-best-products"
                className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
              >
                Best Products
              </Link>
              <Link
                to="/acbuyspreadsheet-alternatives"
                className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
              >
                Alternatives
              </Link>
              <Link
                to="/acbuyspreadsheet-2026"
                className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
              >
                2026 Updates
              </Link>
              <Link
                to="/acbuyspreadsheet-save-money"
                className="text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
              >
                Save Money
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright bar */}
      <div className="border-t border-background-50/10">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} ACBuy Wiki. All rights reserved.
          </p>
          <div className="flex items-center gap-6 flex-wrap">
            <Link
              to="/"
              className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors duration-200"
            >
              Home
            </Link>
            <Link
              to="/acbuyspreadsheet-guide"
              className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors duration-200"
            >
              Guide
            </Link>
            <Link
              to="/acbuyspreadsheet-pricing"
              className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors duration-200"
            >
              Pricing
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors duration-200"
            >
              Main Site
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}